import { AdvancedSearchFilteredCategories } from 'Components/AdvancedSearchFilteredCategories';
import { AdvancedSearchContext } from 'Context/PaymentDeductionContext/AdvancedSearchProvider';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { getPaymentDeductionStatus } from 'Utils/getPaymentStatus';
import { format } from 'date-fns';
import { useContext, useEffect, useState } from 'react';

interface ISearchCategories {
  value?: string | number;
  multiChoiceValue?: {
    value: string;
    searchValueID: number;
  }[];
  searchValueID: number;
}

interface IFilteredCategories {
  resultNumber: number;
  dispatchPaymentsDeductions: Function;
}

export const FilteredCategories = ({
  resultNumber,
  dispatchPaymentsDeductions,
}: IFilteredCategories) => {
  const [searchCategories, setSearchCategories] = useState<ISearchCategories[]>(
    []
  );
  const { advancedSearch, dispatchAdvancedSearch } = useContext(
    AdvancedSearchContext
  );

  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.PaymentsDeductions
  ).search;

  const maxSingleSearchFieldsID = 3; // The max ID search field where its singular const and not an array.

  useEffect(() => {
    const categories = [];
    const { requestState, requestNumber, requestType, dateRange } =
      advancedSearch;
    if (requestState)
      categories.push({
        value: getPaymentDeductionStatus(requestState, dictionary.options).text,
        searchValueID: 1,
      });
    if (requestNumber)
      categories.push({
        value: requestNumber.toString(),
        searchValueID: 2,
      });
    if (requestType.refund || requestType.deduction || requestType.payment) {
      const requestTypes = [];
      if (requestType.refund)
        requestTypes.push({
          value: dictionary.groupStatus.refund,
          searchValueID: 1,
        });
      if (requestType.deduction)
        requestTypes.push({
          value: dictionary.groupStatus.deduction,
          searchValueID: 2,
        });
      if (requestType.payment)
        requestTypes.push({
          value: dictionary.groupStatus.payment,
          searchValueID: 3,
        });
      categories.push({
        multiChoiceValue: requestTypes,
        searchValueID: 3,
      });
    }
    if (dateRange.start || dateRange.end) {
      const dateChoices = [];
      if (dateRange.start) {
        dateChoices.push({
          value:
            dictionary.fromDate +
            ' ' +
            format(new Date(dateRange.start), 'dd/MM/yyyy'),
          searchValueID: 1,
        });
      }
      if (dateRange.end)
        dateChoices.push({
          value:
            dictionary.toDate +
            ' ' +
            format(new Date(dateRange.end), 'dd/MM/yyyy'),
          searchValueID: 2,
        });
      categories.push({
        multiChoiceValue: dateChoices,
        searchValueID: 4,
      });
    }
    if (categories.length === 0 && advancedSearch.activeSearch.advanced)
      dispatchAdvancedSearch({
        type: 'RESET',
      });
    setSearchCategories(categories);
  }, [advancedSearch, dictionary, dispatchAdvancedSearch]);

  const removeCategoryHandler = (
    event: any,
    searchValueID: number,
    subValueFieldID: number
  ) => {
    dispatchAdvancedSearch({
      type: 'REMOVE_SEARCH_OPTION',
      payload: { searchValueID, subValueFieldID },
    });
  };

  useEffect(() => {
    if (advancedSearch.activeSearch.advanced)
      dispatchPaymentsDeductions({
        type: 'ADVANCED_SEARCH',
        payload: { value: advancedSearch },
      });
  }, [advancedSearch, dispatchPaymentsDeductions]);

  return (
    <>
      {(searchCategories.length > 0 && advancedSearch.activeSearch.advanced) ||
      advancedSearch.activeSearch.text ? (
        <AdvancedSearchFilteredCategories
          resultNumber={resultNumber}
          searchCategories={searchCategories}
          removeSearchCategory={removeCategoryHandler}
          maxSingleSearchFieldsID={maxSingleSearchFieldsID}
        />
      ) : null}
    </>
  );
};
